export default "__VITE_ASSET__CIuFBwY6__"